import { createContext, Dispatch, RefObject, SetStateAction } from "react";
import { ReactCropperElement } from "react-cropper";

type CropperContextType = {
  isDisabled?: boolean;
  isCropActive: boolean;
  submitCrop: () => void;
  destroyCrop: () => void;
  imageToBeCropped: string;
  status: "enabled" | "disabled";
  cropperRef: RefObject<ReactCropperElement>;
  setIsCropActive: Dispatch<SetStateAction<boolean>>;
  setImageToBeCropped: Dispatch<SetStateAction<string>>;
  setStatus: Dispatch<SetStateAction<"enabled" | "disabled">>;
};

const CropperContext = createContext<CropperContextType | null>(null);

export type { CropperContextType };
export { CropperContext };
